import { PrismReadOnlyToolbar, PrismSurfaceTheme } from '@lender/prism-editor';

export const getSurfaceTheme = ({ palette }) =>
  palette.mode === 'dark' ? PrismSurfaceTheme.Dark : PrismSurfaceTheme.Light;

// A field disabled while it saves keeps its toolbar on screen, greyed out; a locked one hides it,
// as the CKEditor field did.
export const getReadOnlyToolbar = ({ readOnly, disabled }) =>
  disabled && !readOnly ? PrismReadOnlyToolbar.Disable : PrismReadOnlyToolbar.Hide;
